<template>
  <div>
    <button @click="$router.push({ path: '/feedback' })" class="primary-button feedback-button">Feedback</button>
  </div>
</template>

<script>
export default {
}
</script>

<style>
.feedback-button {
    position: fixed;
    bottom: 5px;
    left: 5px;
}
</style>